import { Icon } from 'antd'
import React, { FC, useLayoutEffect, useState } from 'react'

import styles from '../styles/UploadFile.module.css'

type MyUploadProp = {
  multiple?: boolean
  onChange: React.ChangeEventHandler<HTMLInputElement>
  accept: string
  draggable?: boolean
  style?: React.CSSProperties
  id: string
  editIcon?: boolean
}
let UploadFileNum = 0
const prefix = 'upload-input-'
const makeId = () => {
  UploadFileNum += 1
  return prefix + UploadFileNum
}
const UploadFile: FC<MyUploadProp> = ({
  multiple,
  onChange,
  accept,
  children,
  draggable,
  style,
  id,
  editIcon,
}) => {
  const [myId, setMyId] = useState('')
  useLayoutEffect(() => {
    setMyId(makeId())
  }, [])
  return (
    <div
      onDragOver={(e) => {
        e.stopPropagation()
        e.preventDefault()
      }}
      onDrop={(e) => {
        e.preventDefault()
        e.stopPropagation()
        if (e.dataTransfer.files.length > 0) {
          onChange({
            target: {
              files: e.dataTransfer.files,
            },
          } as any)
        }
      }}
      className={styles.wrapper}
      style={style}
    >
      {editIcon ? (
        <div className={styles.withEditIconWrapper}>
          <label htmlFor={id}>
            <Icon type="edit" className="hover-icon" />
          </label>
          <input
            id={id}
            draggable={draggable}
            accept={accept}
            type="file"
            multiple={multiple}
            onChange={onChange}
          />
        </div>
      ) : (
        <div className={styles.noEditIconWrapper}>
          <label htmlFor={id}></label>
          <input
            id={id}
            draggable={draggable}
            accept={accept}
            type="file"
            multiple={multiple}
            onChange={onChange}
          />
        </div>
      )}

      {children}
    </div>
  )
}

export default UploadFile
